import { render } from "./H2H.vue?vue&type=template&id=4afc570c&scoped=true"
import script from "./H2H.vue?vue&type=script&lang=js"
export * from "./H2H.vue?vue&type=script&lang=js"

import "./H2H.vue?vue&type=style&index=0&id=4afc570c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afc570c"]])

export default __exports__